import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import cls from './SucсessPage.module.scss';
import sberLogo from '@/shared/assets/icons/sberLogoBig.svg';
import { useAcquiringStore } from '../../model/store/useAcquiringStore';
import { Wrapper } from '@/shared/ui/Wrapper';
import { PageLoader } from '@/shared/ui/PageLoader';
import { useCheckPayment } from '../../lib/query/useCheckPayment';

const SucсessPage = () => {
    const { setIsAcquiring } = useAcquiringStore();
    const { mutate, isPending } = useCheckPayment();

    const [searchParams, setSearchParms] = useSearchParams('');

    useEffect(() => {
        if (searchParams.get('orderId') !== null) {
            mutate(searchParams.get('orderId') as string);
            setSearchParms({});
        }
    }, [searchParams.size !== 0]);

    useEffect(() => {
        setIsAcquiring(true);
        return () => setIsAcquiring(false);
    }, []);

    if (isPending) {
        return (
            <Wrapper>
                <PageLoader />
            </Wrapper>
        );
    }

    return (
        <div className={cls.wrapper}>
            <img className={cls.image} src={sberLogo} alt="" />
            <h3>Ваш полис успешно оформлен</h3>
            <p>Страховой полис по вашему договору страхования направлен вам на электронную почту</p>
            <Link to="/" className={cls.btn}>
                Вернуться на главную
            </Link>
        </div>
    );
};

export default SucсessPage;
